module.exports = __webpack_public_path__ + "img/37200.0ca022ab.jpg";